export const ContractorThemes = {
  default: {
    id: "default",
    title: "NUVE default",
    backgroundGradient: "linear-gradient(114deg, #4ae9ff 3.88%, #627afa 94.88%)",
  },
  electric_lagoon: {
    title: "Electric Lagoon",
    backgroundGradient: "linear-gradient(108.91deg, #7243F0 0%, #79ECED 100%)",
  },
  lavender_rose: {
    title: "Lavender Rose",
    backgroundGradient: "linear-gradient(108.91deg, #B6A7FA 0%, #F6BDDE 100%)",
  },
  deep_ocean: {
    title: "Deep Ocean",
    backgroundGradient: "linear-gradient(108.66deg, #3D2CD3 0%, #1193B0 101.09%)",
  },
  forest_spring: {
    title: "Forest Spring",
    backgroundGradient: "linear-gradient(108.91deg, #038083 0%, #20CD5F 100%)",
  },
  royal_sunset: {
    title: "Royal Sunset",
    backgroundGradient: "linear-gradient(108.91deg, #4E5AE3 0%, #E47D80 100%)",
  },
  midnight_rose: {
    title: "Midnight Rose",
    backgroundGradient: "linear-gradient(108.66deg, #0A032F 0%, #F76376 101.09%)",
  },
  twilight: {
    title: "Twilight",
    backgroundGradient: "linear-gradient(108.91deg, #7E7AF5 0%, #051B2D 100%)",
  },
  desert_sun: {
    title: "Desert Sun",
    backgroundGradient: "linear-gradient(108.91deg, #F07F79 0%, #EAA328 100%)",
  },
}

export type ContractorThemeKey = keyof typeof ContractorThemes
